import {
  Component,
  inject,
  OnInit,
  ChangeDetectionStrategy,
  signal,
} from '@angular/core';
import { MenuService } from './services/menu.service';
import { MenuItem } from 'primeng/api';
import { GlobalLoadingService } from 'app/core/services/loading.service';
import { BrandService } from 'app/core/services/brand.service';
import { Observable } from 'rxjs';

/**
 * Admin Layout Component - Angular 19
 * Layout com sidebar colapsável
 */
@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrl: './admin-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'flex w-full h-screen relative',
  },
  standalone: false,
})
export class AdminLayoutComponent implements OnInit {
  private globalLoadingService = inject(GlobalLoadingService);
  private menuService = inject(MenuService);
  private brandService = inject(BrandService);

  menuItems$!: Observable<MenuItem[]>;
  loading$!: Observable<boolean>;

  isMenuCollapsed = signal(false);
  brandConfig = this.brandService.config;

  ngOnInit() {
    this.menuItems$ = this.menuService.menuItems;
    this.loading$ = this.globalLoadingService.loading$;
  }

  /**
   * Toggle do menu colapsado
   */
  toggleMenuCollapse(): void {
    this.isMenuCollapsed.set(!this.isMenuCollapsed());
  }
}
